import { useEffect } from 'react';

export const useSyncWithExternalTabStore = ({ tab, setExternalTabStore }: { tab: 'broker' | 'employer'; setExternalTabStore: (tab: number) => void }) => {
	useEffect(() => {
		setExternalTabStore(tab === 'broker' ? 0 : 1);
	}, [tab]);
};
